import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDelivereasyLogoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	style: {
		shapeRendering: "geometricPrecision",
		textRendering: "geometricPrecision",
		imageRendering: "optimizeQuality",
		fillRule: "evenodd",
		clipRule: "evenodd"
	},
	viewBox: "-0.5 -0.5 128 128",
	id: "delivereasy-logo-icon_icon",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#f1e6d6",
			d: "M73.5-.5h5q17.531 2.35 31 14 7.239 7.39 1 15.5a42.5 42.5 0 0 1-11 5.5q.618 9.963 9 16.5a51.1 51.1 0 0 0 16 5q1.786 1.047 3 2.5v5a453 453 0 0 1-19 54 33.7 33.7 0 0 1-2-9 848 848 0 0 0 15-45.5q-.064-4.85-4-2.5-22.901-4.9-26-28 .68-1.437 2-2.5a41.9 41.9 0 0 0 12.5-5.5q1.411-3.735-1.5-6Q85.435 2.622 60.5 7 26.394 16.6 21 51.5q-1.116 17.177 7.5 32-1.054 3.324-4 5.5l-16 6q-5.799 3.46-3 9.5l-2 5q-3.357-5.043-4-11v-3q1.047-3.25 4-5.5a52.9 52.9 0 0 1 16-5.5Q2.03 40.617 38.5 10 55.04.751 73.5-.5",
			style: { opacity: .995 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#edc715",
			d: "M101.5 20.5h-5q-16.22 1.74-30 10-1.487-.258-2 1-17.805 6.888-27 23.5.042 1.605 1 2.5 1.172 5.67 5 10a9561 9561 0 0 0 9 10 4.45 4.45 0 0 1-2 1.5l-16 1a15.7 15.7 0 0 0-4 2.5q-10.425-16.19-7-35 2.135-3.021 2-7Q37.378 9.416 71 7.5q17.658.718 31.5 11.5-.834.575-1 1.5",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#3e331f",
			d: "M104.5 18.5q-1.083 1.577-3 2 .166-.925 1-1.5Q88.658 8.218 71 7.5q-33.622 1.915-45.5 33-2.135 3.021-2 7-3.425 18.81 7 35a15.7 15.7 0 0 1 4-2.5l16-1a4.45 4.45 0 0 0 2-1.5 9561 9561 0 0 1-9-10l2-1q3.398 6.15 9.5 10 .76 2.244-1.5 3.5l-17 1q-4.053 1.518-7 4.5.258-1.487-1-2-8.616-14.823-7.5-32Q26.394 16.6 60.5 7q24.935-4.378 44 11.5",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e4dacc",
			d: "M99.5 22.5q.244 5.16-5 6-1.195-.686-1-2-1.1-1.812-1-4z",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e7decb",
			d: "M91.5 29.5q-9.535 9.245-12-4 4.62-.372 9-2 3.712 1.766 3 6",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#473d23",
			d: "m96.5 20.5 3 2h-7q-.1 2.188 1 4l-2 3q.712-4.234-3-6a33.4 33.4 0 0 1-9 2q-1.5.5-2 2a50 50 0 0 0-9 3h-2q13.78-8.26 30-10",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e9decf",
			d: "M77.5 27.5q3.379 4.166 2 9a53 53 0 0 1-6.5 2q-3.75-1.934-5.5-6 .544-1.025 1-2a50 50 0 0 1 9-3",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2d2921",
			d: "M104.5 18.5q2.911 2.265 1.5 6A41.9 41.9 0 0 1 93.5 30q-1.32 1.063-2 2.5l-2 2q-.09-.814-1-1-1.329 1.238-1 3-1.142-1.336-3-2-2.334 1.57-5 2 1.379-4.834-2-9 .5-1.5 2-2 2.465 13.245 12 4l2-3q-.195 1.314 1 2 5.244-.84 5-6l-3-2h5q1.917-.423 3-2",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#c7c2b7",
			d: "M101.5 21.5q5.185.25 1 3-1.329-1.237-1-3",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ebe0d0",
			d: "M64.5 32.5q9.235 9.3-4 12-3.912-2.316-4-7 4.56-1.77 8-5",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#211f1d",
			d: "M66.5 30.5h2q-.456.975-1 2 1.75 4.066 5.5 6a53 53 0 0 0 6.5-2q2.666-.43 5-2 1.858.664 3 2 5.99 20.99 27 27l2 2q.257 1.487-1 2h-1q-2.193-1.456-4 1l-2 2q-3.868-.16-7 2l-2 2-6 2q.257-1.487-1-2-2.125-9.587-12-11-4.18-1.465-9-1h-3a47.7 47.7 0 0 0-16-.5q-4.108 1.539-7 4.5l-2 1q-3.828-4.33-5-10a5.73 5.73 0 0 1 1-3q3.442-.954 5-4h3a33 33 0 0 0 8.5-4q.615-3.293-1.5-6l2-3q.088 4.684 4 7 13.235-2.7 4-12v-1q.513-1.258 2-1",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e8ddce",
			d: "M54.5 40.5q2.115 2.707 1.5 6a33 33 0 0 1-8.5 4q-2.42-2.007-1.5-5a25.6 25.6 0 0 0 6.5-5.5q1.405-1.038 2 .5",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#c1a728",
			d: "M89.5 34.5q5.497 22.496 28 28-1.238 1.329-3 1-21.01-6.01-27-27-.329-1.762 1-3 .91.186 1 1",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#a99121",
			d: "M25.5 40.5q.135 3.979-2 7-.135-3.979 2-7",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#3e3520",
			d: "M91.5 32.5q3.099 23.1 26 28 3.936-2.35 4 2.5a848 848 0 0 1-15 45.5q-3.165 6.003-4 13a1069 1069 0 0 1-54.5-20 71 71 0 0 0-11.5 8.5q-2.288 1.513-5 1.5a144 144 0 0 0 12-9.5q2.576-2.338 6-2.5 1.487-.257 2 1a318.7 318.7 0 0 0 50 18 5376 5376 0 0 1 17.5-55q-1.062 1.32-2.5 2l-2-2q1.762.329 3-1-22.503-5.504-28-28z",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#373120",
			d: "M64.5 31.5v1q-3.44 3.23-8 5l-2 3q-.595-1.538-2-.5a25.6 25.6 0 0 1-6.5 5.5q-.92 2.993 1.5 5h-3q-.424-1.184-1.5-2-2.92 2.345-3.5 6a5.73 5.73 0 0 0-1 3q-.958-.895-1-2.5 9.195-16.612 27-23.5",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#cbc5b5",
			d: "M44.5 50.5q-1.558 3.046-5 4 .58-3.655 3.5-6 1.076.816 1.5 2",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#43380d",
			d: "M43.5 37.5q1.314-.195 2 1a488 488 0 0 1-16.5 13q-1.285 4.575 2 8l9 10q1.032 1.248-.5 2a134 134 0 0 0-9.5-10q-6.15-6.727-.5-13.5a157 157 0 0 0 14-10.5",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#df462a",
			d: "M68.5 62.5q12.978 20.319-11 25.5-8.486.75-17 .5-9.864 1.625-12.5 11a139 139 0 0 1 8.5-8.5 61 61 0 0 1 11-.5q13.606 1.038 24.5-7 6.61-9.355.5-19 3.672-1.46 8-1 9.875 1.413 12 11 .522 5.377-2 10-6.042 8.797-16 12.5-12.692 1.5-25 2.5-3.424.162-6 2.5a144 144 0 0 1-12 9.5q-13.53 1.86-23.5-7-3.435-5.002 1.5-8.5a86 86 0 0 0 17-6q2.462-1.694 3-4.5 2.947-2.982 7-4.5l17-1q2.26-1.256 1.5-3.5-6.102-3.85-9.5-10 2.892-2.961 7-4.5a47.7 47.7 0 0 1 16 .5",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#983a26",
			d: "M71.5 62.5q4.82-.465 9 1-4.328-.46-8 1-1.257-.513-1-2",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#bdb9af",
			d: "M114.5 67.5a14.7 14.7 0 0 0-3.5 3 2.43 2.43 0 0 1-.5-2q1.807-2.456 4-1",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e0d8c9",
			d: "M108.5 70.5q-.665 4.686-5 7-2.175-2.024-2-5 3.132-2.16 7-2",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#383020",
			d: "M114.5 67.5h1q-3.12 5.38-8 9.5a120 120 0 0 1-17 9.5v-2q2.522-4.623 2-10 1.257.513 1 2a9.86 9.86 0 0 0 1 6 36.2 36.2 0 0 0 7-4q-1.695-1.683-2-4l2-2q-.175 2.976 2 5 4.335-2.314 5-7l2-2a2.43 2.43 0 0 0 .5 2 14.7 14.7 0 0 1 3.5-3",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dbd1c3",
			d: "M99.5 74.5q.305 2.317 2 4a36.2 36.2 0 0 1-7 4 9.86 9.86 0 0 1-1-6z",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#562318",
			d: "M68.5 62.5h3q-.257 1.487 1 2 6.11 9.645-.5 19-10.894 8.038-24.5 7l-7-2q8.514.25 17-.5 23.978-5.181 11-25.5",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#802d1c",
			d: "m40.5 88.5 7 2a61 61 0 0 0-11 .5 139 139 0 0 0-8.5 8.5q2.636-9.375 12.5-11",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#eac416",
			d: "M51.5 100.5q16.82 1.613 32-5.5 4.42-3.654 7-8.5a120 120 0 0 0 17-9.5q4.88-4.12 8-9.5 1.257-.513 1-2 1.438-.68 2.5-2a5376 5376 0 0 0-17.5 55 318.7 318.7 0 0 1-50-18",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#3e350c",
			d: "M107.5 81.5q1.314-.195 2 1-6.715 6.609-16 7.5l12-6q1.321-1.062 2-2.5",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#432813",
			d: "M90.5 84.5v2q-2.58 4.846-7 8.5-15.18 7.113-32 5.5-.513-1.257-2-1 12.308-1 25-2.5 9.958-3.703 16-12.5",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#453229",
			d: "M28.5 83.5q1.258.513 1 2-.538 2.807-3 4.5a86 86 0 0 1-17 6q-4.935 3.498-1.5 8.5 9.97 8.86 23.5 7-15.15 5.126-26-7-2.799-6.04 3-9.5l16-6q2.946-2.176 4-5.5",
			style: { opacity: 1 }
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e8ddce",
			d: "M106.5 108.5a33.7 33.7 0 0 0 2 9q-.017 6.972-6 10h-3a789 789 0 0 0-47-18.5q-6.597-2.063-10 4-16.91 9.944-35 2-2.946-2.176-4-5.5l2-5q10.85 12.126 26 7 2.712.013 5-1.5a71 71 0 0 1 11.5-8.5 1069 1069 0 0 0 54.5 20q.835-6.997 4-13",
			style: { opacity: .995 }
		})
	]
});
export { SvgDelivereasyLogoIcon as ReactComponent };
